// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Util_Config = require("./Util_Config.bs.js");

function error2(v1, v2) {
  Util_Config.runOnlyInDev(function (param) {
        console.error(v1, v2);
      });
}

exports.error2 = error2;
/* Util_Config Not a pure module */
